import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    sendBusinessServiceEnquiry,
    sendConsultingServiceEnquiry,
    sendImportExportServiceEnquiry,
    sendMedicalTourismServiceEnquiry,
    sendMigrationServiceEnquiry,
    sendPropertyManagementServiceEnquiry,
    sendRealEstateServiceEnquiry,
    sendRelocationSupportServiceEnquiry,
    sendResidenceServiceEnquiry,
    sendWorkAbroadServiceEnquiry,
} from "../../redux/thunks/services";

const InquiryForm = ({ formFields, serviceId }) => {
    const getInitialFormState = (fields) => {
        const state = {};
        fields.forEach((field) => {
            state[field.name] = field.type === "select" ? "" : ""; // default values
        });
        return state;
    };

    const { isLoading } = useSelector((state) => state.servicesReducer);

    const dispatch = useDispatch();
    const [formData, setFormData] = useState();


    //   const handleChange = (e) => {
    //     console.log(e.target.type);

    //     const { name, value } = e.target;
    //     setFormData((prev) => ({ ...prev, [name]: value }));
    //   };

    const handleChange = async (e) => {
        const { name, type, files, value, multiple, options } = e.target;

        if (type === "file" && files.length > 0) {
            const file = files[0];

            // Optional: validate file type and size
            if (file.type !== "application/pdf") {
                alert("Please upload a valid PDF file.");
                return;
            }

            if (file.size > 2 * 1024 * 1024) {
                alert("File size should not exceed 2MB.");
                return;
            }

            const toBase64 = (file) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result); // base64 string
                    reader.onerror = (error) => reject(error);
                });

            try {
                const base64String = await toBase64(file);
                setFormData((prev) => ({
                    ...prev,
                    [name]: base64String,
                }));
            } catch (error) {
                console.error("Base64 conversion failed:", error);
            }
        }
        else if (multiple) {
            let newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
            setFormData((prev) => ({
                ...prev,
                [name]: newValue,
            }));
        } else {
            // handle text/number/etc. fields
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    useEffect(() => {
        setFormData(getInitialFormState(formFields));
    }, [serviceId, formFields]);

    //   const handleSubmit = (event) => {
    //     event.preventDefault();
    //     // Handle form submission logic here (e.g., send data to an API)
    //     console.log("Form submitted for service ID:", serviceId);
    //     const formData = {};
    //     formFields.forEach((field) => {
    //       if (field.name) {
    //         formData[field.name] = event.target[field.name].value;
    //       }
    //     });
    //     console.log("Form Data:", formData);
    //     // Optionally reset the form
    //     event.target.reset();
    //   };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            switch (serviceId) {
                case "import-export-services": {
                    const adddata = {
                        name: formData?.fullName,
                        company_name: formData?.companyName,
                        country_of_interest: formData?.country,
                        imp_exp_req: parseInt(formData?.requirements),
                        phone: formData?.phone,
                        email: formData?.email,
                        description: formData?.description,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    // console.log(adddata);

                    await dispatch(sendImportExportServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "migration-services": {
                    const adddata = {
                        name: formData?.fullName,
                        company_name: formData?.companyName,
                        current_country_of_residence: formData?.currentCountry,
                        timeline_for_migrations: formData?.timeline,
                        target_countries: formData?.targetCountry,
                        type_of_visa: parseInt(formData?.visaType),
                        phone: formData?.phone,
                        email: formData?.email,
                        description: formData?.description,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    //   console.log(adddata);

                    await dispatch(sendMigrationServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "residency-by-investment": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        current_citizenship: formData?.citizenship,
                        family_members_to_include: formData?.familyMembers,
                        timeline_expectations: formData?.timeline,
                        countries_of_interest: formData?.countriesOfInterest,
                        invest_budget_range: parseInt(formData?.budget),
                        invest_pref: parseInt(formData?.investmentPreference),
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    // console.log(adddata);
                    
                    await dispatch(sendResidenceServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "business-buy-sale-services":{
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        company_name:
                            formData?.companyName != "" && formData?.companyName != undefined
                                ? formData?.companyName
                                : null,
                        industry_sector: formData?.industry,
                        business_size: formData?.sizeOrBudget,
                        timeline_for_transaction: formData?.timeline,
                        description: formData?.description,
                        target_countries: formData?.targetCountries,
                        interest: parseInt(formData?.interest),
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendBusinessServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    //   document.getElementById(serviceId)?.reset();
                    window.location.reload();
                    break;
                }
                case "real-estate": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        country_of_intrest: formData?.location,
                        budget_range: formData?.budget,
                        timeline: formData?.timeline,
                        property_Requirements: formData?.requirements,
                        investment_purpose: formData?.purpose,
                        service_req: parseInt(formData?.serviceRequired),
                        property_type: parseInt(formData?.propertyType),
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendRealEstateServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    //   document.getElementById(serviceId)?.reset();
                    window.location.reload();
                    break;
                }
                case "consulting-services": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        company_name: formData?.companyName,
                        position_title: formData?.position,
                        industry_sector: formData?.industry,
                        primary_business_challenge: formData?.challenge,
                        project_timeline: formData?.timeline,
                        description: formData?.description,
                        company_size: parseInt(formData?.companySize),
                        consulting_area: parseInt(formData?.consultingArea),
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendConsultingServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    //   document.getElementById(serviceId)?.reset();
                    window.location.reload();
                    break;
                }
                case "relocation-in-india": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        country_of_resd: formData?.currentCountry,
                        target_city_india: formData?.targetCity,
                        relocation_timeline: formData?.timeline,
                        children_ages: formData?.childrenAges,
                        housing_requirements: formData?.housingRequirements,
                        staff_requirements: formData?.staffRequirements,
                        special_considerations: formData?.specialConsiderations,
                        school_requirements: formData?.schoolRequirements,
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendRelocationSupportServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "work-abroad": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        current_prof_industry: formData?.profession,
                        years_of_exp: formData?.experience,
                        current_location: formData?.location,
                        educational_qualification: formData?.education,
                        language_prof: formData?.languages,
                        pref_destinations: formData?.destinations,
                        career_objectives: formData?.objectives,
                        resume_base64: formData?.resume,
                        timeline_for_reloaction: formData?.timeline,
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendWorkAbroadServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "property-management-services-in-india": {
                    //   console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        country_of_resd: formData?.currentCountry,
                        property_loaction_india: formData?.propertyLocation,
                        property_type: formData?.propertyType,
                        current_property_status: formData?.propertyStatus,
                        service_required: formData?.servicesRequired,
                        property_concerns: formData?.concerns,
                        management_timeline: formData?.timeline,
                        no_of_proprties: formData?.numberOfProperties,
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    //   console.log(adddata);
                    await dispatch(sendPropertyManagementServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                case "medical-tourism-services": {
                    console.log(formData);
                    const adddata = {
                        name: formData?.fullName,
                        country_of_resd: formData?.currentCountry,
                        medical_condition_req: formData?.medicalCondition,
                        treatment_timeline: formData?.treatmentTimeline,
                        pref_destination: formData?.preferredDestination,
                        insurance_coverage_status: formData?.insuranceStatus,
                        mobility_assistance_req: parseInt(formData?.mobilityAssistance),
                        budget_range: formData?.budgetRange,
                        previous_international_treatment_exp: formData?.previousExperience,
                        spcl_medical_req: formData?.specialRequirements,
                        phone: formData?.phone,
                        email: formData?.email,
                        hear_about_us: formData?.hearAboutUs,
                        pref_conatct_method: parseInt(formData?.contactMethod),
                        consent_to_privacy_policy: true,
                    };
                    await dispatch(sendMedicalTourismServiceEnquiry(adddata)).unwrap();
                    setFormData(getInitialFormState(formFields));
                    window.location.reload();
                    break;
                }
                default:
                    console.warn("No thunk defined for this service");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    return (
        <form
            id={serviceId}
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
            {formFields?.map((field, index) => (
                <div
                    key={index}
                    className={field.type === "textarea" ? "col-span-full" : ""}
                >
                    <label
                        htmlFor={field.name}
                        className={`block text-gray-700 text-sm font-bold mb-2 ${field.required ? "" : "opacity-75"
                            }`}
                    >
                        {field.label}
                    </label>
                    {field.type === "text" && (
                        <input
                            type="text"
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                            onChange={handleChange}
                        />
                    )}
                    {field.type === "number" && (
                        <input
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            className="no-spinner shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                            onChange={handleChange}
                        />
                    )}
                    {field.type === "file" && (
                        <input
                            type="file"
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            accept="application/pdf"
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                        />
                    )}
                    {field.type === "email" && (
                        <input
                            type="email"
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                        />
                    )}
                    {field.type === "tel" && (
                        <input
                            type="tel"
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                        />
                    )}
                    {field.type === "select" && (
                        <select
                            multiple={field?.multiple}
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                            onChange={handleChange}
                        >
                            <option value="">Select an option</option>
                            {field.options &&
                                field.options.map((option, i) => (
                                    <option key={i} value={option?.value}>
                                        {option?.label}
                                    </option>
                                ))}
                        </select>
                    )}
                    {field.type === "textarea" && (
                        <textarea
                            id={`${serviceId}_${field.name}`}
                            name={field.name}
                            onChange={handleChange}
                            rows="4"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required={field.required}
                        ></textarea>
                    )}
                </div>
            ))}
            <div className="col-span-full">
                <label className="inline-flex items-center">
                    <input
                        type="checkbox"
                        onChange={handleChange}
                        className="form-checkbox h-5 w-5 text-basecolor rounded focus:outline-none focus:shadow-outline"
                        required
                    />
                    <span className="ml-2 text-gray-700 text-sm">
                        I consent to the privacy policy*
                    </span>
                </label>
            </div>

            <div className="col-span-full text-right mt-3">
                <button
                    type="submit"
                    className="bg-basecolor text-white font-semibold py-3 px-6 rounded-md hover:bg-textcolor-dark focus:outline-none focus:shadow-outline flex items-center justify-center gap-2"
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                />
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                />
                            </svg>
                            <span>Submitting...</span>
                        </>
                    ) : (
                        'Submit Inquiry'
                    )}
                </button>

            </div>
        </form>
    );
};

export default InquiryForm;
